<div class="schedule-content">
  @if (newTask) {
    <h2>Does this task repeat?</h2>
    <div class="row">
      <button
        (click)="onScheduleType('doNotRepeat')"
        class="schedule-button"
        [class.selected-row-button]="scheduleControl.get('scheduleType').value === 'doNotRepeat'"
      >
        Single Task
      </button>
      <button
        (click)="onScheduleType('repeats')"
        class="schedule-button"
        [class.selected-row-button]="scheduleControl.get('scheduleType').value === 'repeats'"
      >
        Repeating Task
      </button>
    </div>
  } @else {
    <oph-button-group
      class="mb-30"
      [options]="viewOptions"
      [selectedOptionName]="scheduleControl.get('scheduleType').value"
      [classes]="newTask ? '' : 'light-bg ' + ' task-item-variable-bg'"
      [buttonStyle]="{
        'font-size': '15px',
        'border-radius': '4px'
      }"
      (optionClick)="onScheduleType($event)"
    ></oph-button-group>
  }

  <!-- ------------------------------------------------------------------------------- -->
  <!-- ----------------------------NO REPEAT TASK-------------------------------- -->
  <!-- ------------------------------------------------------------------------------- -->
  @if (scheduleControl.get('scheduleType').value === 'doNotRepeat') {
    <h2>When can the task be started?</h2>
    <div class="row">
      <button
        (click)="onScheduleOnDateType('asap')"
        class="schedule-button"
        [class.task-item-variable-bg]="!newTask"
        [class.selected-row-button]="scheduleControl.get('scheduleOnDateType').value === 'asap'"
      >
        ASAP
      </button>
      <projects-task-date-time-button
        type="date"
        [newTask]="newTask"
        [dateValue]="scheduleControl.get('scheduleOnDate').value"
        [isSelected]="scheduleControl.get('scheduleOnDateType').value !== 'asap'"
        (buttonClick)="onScheduleOnDateType('date')"
      ></projects-task-date-time-button>
      <span>at</span>
      <projects-task-date-time-button
        type="time"
        [newTask]="newTask"
        [dateValue]="scheduleControl.get('scheduleOnDate').value"
        [isSelected]="scheduleControl.get('scheduleOnDateType').value !== 'asap'"
        (buttonClick)="onScheduleOnDateType('date')"
      ></projects-task-date-time-button>
    </div>

    <h2>When does the task end or expire?</h2>
    <div class="row">
      <button
        (click)="onExpirationType('endOfProject')"
        class="schedule-button"
        [class.task-item-variable-bg]="!newTask"
        [class.selected-row-button]="expirationTypeControl.value === 'endOfProject'"
      >
        End of Project
      </button>
      <!-- -----DAYS WEEKS BUTTON----- -->
      <projects-task-dropdown-selector-button
        [newTask]="newTask"
        [isSelected]="expirationTypeControl.value === 'amountOfTime'"
        [dropdownOneOptions]="$any(numberOptions)"
        [dropdownTwoOptions]="repeatTypes"
        [dropdownOneControl]="$any(scheduleControl.get('expirationValue'))"
        [dropdownTwoControl]="$any(scheduleControl.get('expirationValueType'))"
        (buttonClick)="onExpirationType('amountOfTime')"
      ></projects-task-dropdown-selector-button>
      <projects-task-date-time-button
        type="date"
        [newTask]="newTask"
        [dateValue]="scheduleControl.get('expirationDate').value"
        [isSelected]="expirationTypeControl.value === 'date'"
        (buttonClick)="onExpirationType('date')"
      ></projects-task-date-time-button>
    </div>

    <oph-checkbox
      [control]="$any(this.form.get('deleteWhenComplete'))"
      [width]="25"
      textOrientation="right"
      text="Delete task when complete"
      [textStyle]="{
        color: 'var(--Ophanim-Final-Off-black, #4A443D)',
        'font-family': 'Asap',
        'font-size': '15px',
        'font-style': 'normal',
        'font-weight': '400'
      }"
      color="green"
    ></oph-checkbox>
  } @else if (scheduleControl.get('scheduleType').value === 'repeats') {
    <!-- ------------------------------------------------------------------------------- -->
    <!-- ----------------------------REPEATING TASK-------------------------------- -->
    <!-- ------------------------------------------------------------------------------- -->
    <h2>Task repeats every:</h2>
    <div class="row">
      <!-- -----DAYS WEEKS BUTTON----- -->
      <projects-task-dropdown-selector-button
        [newTask]="newTask"
        [dropdownOneOptions]="$any(numberOptions)"
        [dropdownTwoOptions]="['weeks', 'days']"
        [dropdownOneControl]="$any(scheduleControl.get('repeatEvery'))"
        [dropdownTwoControl]="$any(scheduleControl.get('repeatType'))"
        (valueChange)="onRepeatTypeChange($event)"
      ></projects-task-dropdown-selector-button>

      @if (scheduleControl.get('repeatType').value === 'weeks') {
        <span>on</span>
        <oph-week-selector
          [control]="$any(scheduleControl.get('repeatDays'))"
          [selectedGreenBorder]="true"
          [allInvalid]="validationErrors.repeatDays"
          [lightBackground]="newTask"
        ></oph-week-selector>
      }
    </div>

    <h2>When do tasks start?</h2>
    <div class="row">
      <projects-task-date-time-button
        [newTask]="newTask"
        type="date"
        [dateValue]="scheduleControl.get('scheduleOnDate').value"
        (buttonClick)="onScheduleOnDateType('date')"
      ></projects-task-date-time-button>
      <span>at</span>
      <projects-task-date-time-button
        [newTask]="newTask"
        type="time"
        [dateValue]="scheduleControl.get('scheduleOnDate').value"
        (buttonClick)="onScheduleOnDateType('date')"
      ></projects-task-date-time-button>
      <span>ends in</span>
      <button class="ends-in-button" [matMenuTriggerFor]="menu" [class.task-item-variable-bg]="!newTask">
        <img src="assets/img/icons/clock-brown.svg" />

        {{ repeatEndsInDisplay }}
      </button>
      <mat-menu #menu="matMenu" class="oph-select-menu">
        @for (option of repeatEndsInOptions; track option) {
          <button class="oph-select-menu-item" (click)="onRepeatEndsInChange(option)">{{ option }}</button>
        }
      </mat-menu>
    </div>

    <h2>Repeat cycle ends:</h2>
    <div class="row">
      <button
        (click)="onCycleEndsType('endOfProject')"
        class="schedule-button"
        [class.task-item-variable-bg]="!newTask"
        [class.selected-row-button]="scheduleControl.get('cycleEndsType').value === 'endOfProject'"
      >
        End of Project
      </button>

      <!-- Will most likely come back in the future -->
      <!-- -----DAYS WEEKS BUTTON----- -->
      <!-- <projects-task-dropdown-selector-button
        [newTask]="newTask"
        [isSelected]="scheduleControl.get('cycleEndsType').value === 'amountOfTime'"
        [dropdownOneOptions]="numberOptions"
        [dropdownTwoOptions]="['days', 'weeks']"
        [dropdownOneControl]="scheduleControl.get('cycleEndsTimeValue')"
        [dropdownTwoControl]="scheduleControl.get('cycleEndsTimeValueType')"
        (buttonClick)="onCycleEndsType('amountOfTime')"
      ></projects-task-dropdown-selector-button> -->

      <!-- -----TASKS BUTTON----- -->
      <projects-task-input-selector-button
        [newTask]="newTask"
        [isSelected]="scheduleControl.get('cycleEndsType').value === 'tasks'"
        [rightContainerText]="'Tasks'"
        [inputControl]="$any(scheduleControl.get('cycleEndsTaskCountValue'))"
        (buttonClick)="onCycleEndsType('tasks')"
      ></projects-task-input-selector-button>
      <button
        (click)="onCycleEndsType('trigger')"
        class="schedule-button"
        [class.task-item-variable-bg]="!newTask"
        [class.selected-row-button]="scheduleControl.get('cycleEndsType').value === 'trigger'"
      >
        Metric
      </button>
    </div>

    @if (scheduleControl.get('cycleEndsType').value === 'trigger') {
      <task-trigger-selection
        [triggerFormGroup]="$any(scheduleControl.get('cycleEndsTrigger'))"
        [hideXButton]="true"
        [error]="validationErrors.scheduleRepeatsTracker"
        (removeItem)="onRemoveCycleEndsTrigger()"
        (newClick)="newTrackerClick.emit()"
      />
    }
  } @else {
    <!-- ------------------------------------------------------------------------------- -->
    <!-- ----------------------------TRIGGER TASK-------------------------------- -->
    <!-- ------------------------------------------------------------------------------- -->
    <projects-task-triggers
      class="edit-task-triggers"
      [form]="form"
      [newTask]="newTask"
      [isTriggerPanelValid]="$any(isTriggerPanelValid)"
      [validationErrors]="validationErrors"
      (newTrackerClick)="newTrackerClick.emit()"
    ></projects-task-triggers>
  }
</div>
